import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { FiCheckCircle } from "react-icons/fi";
import "./ServicePage.css";

const ServicePage = () => {
  const { "*" : path } = useParams();   // <-- important
  const [service, setService] = useState(null);

  const slug = path.split("/").pop();
  const formattedMenuName = slug.replace(/-/g, " ").toUpperCase();

  useEffect(() => {
    fetch("https://infosightapi.emedha.in/api/services")
      .then(res => res.json())
      .then(data => {
const allowedPartial = ["ICT"]; // add more when needed

const matched = data.find(item => {
    const menu = item.menu_name.toUpperCase();
    const head = item.heading.toUpperCase();

    // EXACT MATCH ALWAYS FIRST
    if (menu === formattedMenuName) return true;
    if (head === formattedMenuName) return true;

    // ALLOWED PARTIAL MATCH ONLY FOR SPECIAL CASES
    if (allowedPartial.includes(formattedMenuName)) {
        return head.includes(formattedMenuName);
    }

    return false; // NO MORE PART MATCHING
});



        setService(matched);
      });
  }, [formattedMenuName]);   // <-- dependency fixed

  if (!service) return <p className="loading-text">Loading...</p>;

  return (
    <>
      <Navbar />

      <section
        className="service-hero"
        style={{ backgroundImage: `url(${service.image})` }}
      >
        <div className="service-hero-overlay" />
        <div className="service-hero-content">
          <h1>{service.heading}</h1>
          <p>
            <a href="/">Home</a> / {service.heading}
          </p>
        </div>
      </section>

      <div className="service-container">
        <div className="service-content">
          <h2 className="service-heading">{service.heading}</h2>
          <p className="service-paragraph">{service.paragraph}</p>

          {service.bullet_points && (
            <ul className="service-bullet-list">
              {JSON.parse(service.bullet_points).map((bullet, index) => (
                <li key={index} className="service-bullet-item">
                  <FiCheckCircle className="bullet-icon" />
                  {bullet.replace(/^•\s*/g, "")}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ServicePage;
